<template>
  <Card :padding="0"  dis-hover :bordered="false"  style="background:#eee;">
    <div ref="toolbar">
    <Card  :padding="0" style="margin-bottom: 5px;" dis-hover>
        <Row type="flex" justify="start" align="middle"  style="padding:5px 10px"  :gutter="16">
            <Col  span='18'>
               <ButtonToolBar  ref="menutoolbar" :config="menuToolbar"  :moduleMethod="moduleMethod" justify="start" @doAction="doAction"/>
            </Col>
            <Col span="6"  >
                <Row type="flex" justify="end" align="middle">
                    <PromptMessage/>
                </Row>
            </Col>
        </Row>
    </Card>
    <Card v-if="false" :padding="5"  dis-hover :bordered="false"  style="margin-bottom: 5px;">
        <BillConditionsBox ref='quick' :config="myConfig.quickQueryConfig.filterConfig" :dictData="dictData" modeType="two"></BillConditionsBox>
    </Card>
    </div>
    <Card :padding="0" :bordered="false" dis-hover>
        <ViewGrid  ref="grid" :config="myConfig.gridConfig" :dictData="dictData" @dbclick="dbclick" />
    </Card>
    <QuickQueryToolbar ref="quick"  :config="myConfig.quickQueryConfig" :dictData="dictData" @on-change="quickChagne" :singleMode="true" :fuzzyQuery="false"/>
  </Card>
</template>

<script>
import QuickQueryToolbar from './quickquerytoolbar.vue';
import PromptMessage from './promptmessage.vue';
import ButtonToolbar from './btntoolbar.vue';
import elementResizeDetectorMaker from 'element-resize-detector';
export default {
    name:'billquerygrid',
    components:{QuickQueryToolbar,PromptMessage,ButtonToolbar},
    data () {
        return {
            myConfig:{
                bindingKey:'ph_key'
            },
            menuToolbar:{},
            gridToolbar:{}
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        }
    },
    created () {
        this.myConfig =  Object.assign({},this.myConfig, this.config);
        this.myConfig.gridConfig.headStyle='';
        this.myConfig.gridConfig.showCondition = false;
        this.myConfig.gridConfig.overrideData = this.gridOverrideData;
        this.myConfig.gridConfig.onSelectionChange = this.gridOnSelectionChange;
        this.myConfig.gridConfig.resources = this.config.resources;
        this.myConfig.gridConfig.height = 1;
        this.myConfig.gridConfig.adjustHeight = 5;
        this.myConfig.gridConfig.method = this.config.classPrefix + '.search';
        this.myConfig.gridConfig.response = this.config.response;
        this.myConfig.gridConfig.items.forEach(el => {
            if (el.type !== 'CheckBox') {
                if (el.tooltip === undefined) {
                    el.tooltip = true;
                }
            }
        });
        if (this.myConfig.menuToolbar && this.myConfig.menuToolbar.items) {
            this.menuToolbar = this.$Method.copy(this.myConfig.menuToolbar);
        }
        this.doGridToolbar();
    },
    methods: {
        doMenuToolbar () {
            let flag = false;
            let index  = this.moduleMethod.findIndex(el => el.name === 'addData');
            if (index > -1) {
                flag = true;
            }
            if (this.$refs.menutoolbar) {
                if (flag) {
                    this.$refs.menutoolbar.addBtnObject([{name:'addData',text:'新增'},{name:'searchData',text:'查询'}],'front');
                } else {
                    this.$refs.menutoolbar.addBtnObject([{name:'searchData',text:'查询'}],'front');
                }  
            }
        },
        doGridToolbar ()  {
            if (this.myConfig.gridToolbar && this.myConfig.gridToolbar.items) {
                this.gridToolbar = this.$Method.copy(this.myConfig.gridToolbar);
                /*let index = this.gridToolbar.items.findIndex(el => el.name === 'skipData');
                if (index === -1) {
                    this.gridToolbar.items.splice(0,0,{name:'skipData', text:'详情', type:'text'});
                }*/
            }
            if (this.gridToolbar && this.gridToolbar.items && this.gridToolbar.items.length > 0) {
                this.gridToolbar.items.forEach(el => {
                    el.type ='text';
                    el.size = 'small';
                });
                /*
                let action ={};
                action.label = '操作';
                action.key = 'action';
                action.align = 'center';
                action.render = this.actionRender;
                action.width = 60 * this.gridToolbar.items.length;
                let tempIndex = this.myConfig.gridConfig.items.findIndex(el => el.key === 'action');
                if (tempIndex === -1)  {
                    this.myConfig.gridConfig.items.push(action);
                }
                */
            }  
        },
        actionRender (h, params) {
            return h('div', [
                h('ButtonToolBar', {
                    props: {
                        config:this.gridToolbar,
                        moduleMethod:this.moduleMethod
                    },
                    on: {
                        doAction: (val) => {                       
                            val.para = params.row;
                            this.$emit('doAction',val);
                        }
                    }
                })
            ]);
        },
        doAction (obj) {
            obj.para = this.$refs.grid.getSelection();
            this.$emit('doAction', obj);
        },
        gridOverrideData (data) {
            let self = this;
            if (data && data.length > 0) {
                this.$nextTick(() => {
                    let index = 0;
                    if (self.ph_key) {
                        let culIndex = data.findIndex(el => el[self.myConfig.bindingKey]=== self.ph_key);
                        if (culIndex > -1) {
                            index = culIndex;
                        }
                    }
                    this.$refs.grid.setRowHighlight(index,true);
                });
            }
            return data;
        },
        gridOnSelectionChange(rows) {
            let obj = {};
            obj.name = 'gridSelectionChange';
            obj.para = rows;
            this.$emit('doAction', obj);
        },
        clearData () {
            this.$refs.quick.clearData();
            this.refurbish();
        },
        getSearchParam () {
            //return this.$refs.quick.getQuerySearchParam();
            return this.$refs.quick.getData();
        },
        refurbish () {
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.setSearchBeforeSearchParam(this.getSearchParam());
            this.$refs.grid.refurbish();
        },
        getGrid () {
            return this.$refs.grid;
        },
        getBtnToolbar() {
            return this.$refs.btn;
        },
        getQuick () {
            return this.$refs.quick;
        },
        dbclick (e) {
            let obj = {};
            obj.name ='gridDbClick';
            obj.para = e;
            this.ph_key = obj.para[this.myConfig.bindingKey];
            this.$emit('doAction', obj);
        },
        setPhkey(value) {
            this.ph_key = value;
        },
        quickChagne () {
            this.refurbish();
        },
        setOutsideHeight() {
            let height = this.$refs.toolbar.offsetHeight  + 8;
            this.$refs.grid.setOutsideHeight(height);
        }
    },
    mounted () {
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.toolbar, this.setOutsideHeight);
        this.doMenuToolbar();
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.toolbar, this.setOutsideHeight);
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/billquerygrid.vue